export default "__VITE_ASSET__C$kHBA8m__"